import React, { Component } from 'react'

class Module2 extends Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            this.props.data.length>0 && <section className="section-wrap page2">
                <div className="block column2">
                    <div className="block-body">
                        <div className="block-left">
                            <img width="556" src={this.props.data[0].src}/>
                        </div>
                        <div className="block-right">
                            <h2>{this.props.data[0].title}</h2>
                            <i></i>
                            <p >{this.props.data[0].slogan}</p>
                            
                        </div>
                    </div>
                    <div className="block-body">
                        <div className="block-left">
                            <h2>{this.props.data[1].title}</h2>
                            <i></i>
                            <p dangerouslySetInnerHTML={{__html:this.props.data[1].slogan}}></p>
                        </div>
                        <div className="block-right">
                            <img width="556" src={this.props.data[1].src} />
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Module2